import { BaseEntity } from "yt-ng-framework";

export class FinDokument extends BaseEntity{

    constructor(){
        super();
    }
    PodVrstaDokumentaStavkaID: number = null;
    Broj: string = null;
    Datum: Date = null;
    Url: string = null;
    BrojDokumenta: string = null;
    Duguje:number;
    Potrazuje:number;

    Deserialize(input: any){
        this.ID = input.ID;
        this.PodVrstaDokumentaStavkaID = input.PodVrstaDokumentaStavkaID;
        this.Broj = input.Broj;
        this.Datum = input.Datum;
        this.BrojDokumenta = input.BrojDokumenta;
        this.Duguje = input.Duguje;
        this.Potrazuje = input.Potrazuje;
        
        return this;
    }

    Serialize(input: FinDokument){
        return input;
    }

    GetInstance(){
        return this;
    }
}